export const Collections = {
  mail: 'mails',
  mailTemplates: 'mail_templates',
  speech: 'speech',
} as const;

export const supportedLanguages = ['en', 'de'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export type Memory = {
  content: string;
};

export type Speech = {
  id: string;
  email: string;

  language: SupportedLanguage;
  type: 'best-man' | 'bridesmaid' | 'father' | 'mother';

  model: string;
  prompt: string;
  inputs: {
    name: string;
    groom: string;
    groom_pronoun: string;
    bride: string;
    bride_pronoun: string;
    relationship: string;
    known_since: string;
    memories: Memory[];
  };

  result: {
    preview: string;
    fullSpeech: string;
  };

  createdAt: string;

  payment: null | { isPaid: boolean; session: Record<string, unknown> };
};
